/* Sign-up details between /start and /verify-email, so "Send a new code" can call sign-up again.
   Held in memory only: never written to storage, gone on reload, cleared once the email is verified. */
import type { Lang } from '@pathabroad/core/browser';

export type PendingSignup = { email: string; password: string; dob: string; lang: Lang; minor: boolean; planner?: boolean };
let pending: PendingSignup | null = null;

export const signupMemory = {
  get: (): PendingSignup | null => pending,
  set: (p: PendingSignup) => { pending = p; },
  clear: () => { pending = null; },
};
